"use client"

import { createContext, type RefObject, use } from "react"

export type ModalContextValue = {
  open: boolean
  shake: boolean
  setOpen: (next: boolean) => void
  setShake: (next: boolean) => void
  checkAllowClose: RefObject<Set<() => "deny" | "allow">>
}

export const ModalContext = createContext<ModalContextValue | null>(null)

export const useModalContext = () => {
  const context = use(ModalContext)

  if (!context) {
    throw new Error("Modal components or hooks must be wrapped in <Modal />")
  }

  return context
}
